module.exports = __webpack_public_path__ + "static/media/tableau_bord.6da4cf1c.jpg";